import { FiFormSharedModule } from '@fi-shared/fi-form-shared/fi-form-shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiFormViewerContainerComponent } from '@fi-app/fi-form/fi-form-viewer/fi-form-viewer-container.component';
import { ButtonBackModule } from '@fi-app/utilities/button-back/button-back.module';
import { FiStateSrefModule } from '@fi-app/shared/fi-state-proxy/state-sref/state-sref.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiPrintDownloadModule } from '@fi-shared/fi-print-download/fi-print-download.module';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [
        CommonModule,
        ButtonBackModule,
        FiStateSrefModule,
        FiAppTextSharedModule,
        FiPrintDownloadModule,
        FiFormSharedModule,
        FiPageHeaderButtonGroupModule,
        FiPageHeaderModule,
        MatIconModule,
        MatButtonModule,
    ],
    declarations: [FiFormViewerContainerComponent],
})
export class FiFormViewerModule {}
